import axios from 'axios'

const API_BASEURL = (
  window.customizerapp_url ||
  process.env.VUE_APP_API_BASEURL ||
  'https://fathead-customizer.herokuapp.com'
)

const API_ENDPOINT = `${API_BASEURL}/api/v1/frontend`
const STORE_DOMAIN = window.store_domain || process.env.VUE_APP_STORE_DOMAIN

const request = axios.create({
  baseURL: API_ENDPOINT,
  headers: {
    'Accept': 'application/json',
    'Content-type': 'application/json;charset=UTF-8',
    'Store-Domain': STORE_DOMAIN
  }
})

export default request
